import { render, staticRenderFns } from "./ListDuplicateMid.vue?vue&type=template&id=87d0ca5c"
import script from "./ListDuplicateMid.vue?vue&type=script&lang=js"
export * from "./ListDuplicateMid.vue?vue&type=script&lang=js"
import style0 from "./ListDuplicateMid.vue?vue&type=style&index=0&id=87d0ca5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports